var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"m-0",attrs:{"data-cy":"key-point"}},[_c('img',{staticClass:"my-4 my-xl-5",attrs:{"src":require(`@/assets/svg/${_vm.icon}.svg`),"alt":_vm.icon}}),(_vm.title !== '')?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('h3',{staticClass:"mx-xl-3"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }